export default __webpack_public_path__ + "static/media/edit-entry.d98f403b.webp";